import { render, staticRenderFns } from "./LinkedInPost.vue?vue&type=template&id=5035a270&scoped=true&"
import script from "./LinkedInPost.vue?vue&type=script&lang=js&"
export * from "./LinkedInPost.vue?vue&type=script&lang=js&"
import style0 from "./LinkedInPost.vue?vue&type=style&index=0&id=5035a270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035a270",
  null
  
)

export default component.exports